<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">
        Pregled ruta putničkih vozila - detaljni (odlasci iz preduzeća)
      </h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': this.tabSelector === 0 }">
          <a @click="tabClicked(0)">Danas</a>
        </li>
        <li v-bind:class="{ 'is-active': this.tabSelector === 1 }">
          <a @click="tabClicked(1)">Juče</a>
        </li>
        <li :class="{ 'is-active': this.tabSelector === 2 }">
          <a @click="tabClicked(2)">Proizvoljan period</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content" v-show="this.tabSelector === 2">
      <date-picker v-model="time3" @input="timeSpanChosen" range></date-picker>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        ref="table"
        @cell-click="tableCellClicked"
        @cell-change="onCellChange"
        @cell-contextmenu="cm"
      ></vue-table-dynamic>
    </div>

    <!-- contex menu -->
    <context-menu :display="showContextMenu" ref="menu">
      <ul>
        <li @click="cmViewDetails" v-show="isCmViewDetailsVisible">
          <p style="background-color: lightGreen" class="cmitem">
            Vidi detalje...
          </p>
        </li>
      </ul>
    </context-menu>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic-sum";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import ContextMenu from "../parts/ContextMenu.vue";
import { maskIfEquealsValue, getDateFromTicks } from "../../_helpers/arrangers";
import { colors } from "../../_helpers/colors";

export default {
  name: "RouteReportSimple",
  components: {
    VueTableDynamic,
    DatePicker,
    ContextMenu,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      firstDay: null,
      lastDay: null,
      selectedMonth: 0,
      selectedYear: 0,
      tabSelector: 0,
      employees: [],
      employeeIdsBeenOnRoute: [],
      freightVehicles: [],
      rawData: [],
      showContextMenu: false,
      isCmViewDetailsVisible: true,
      selectedVehicle: {},
      params: {
        data: [
          [
            "Ndx",
            "Vozač",
            "Vozilo",
            "Reg. oznaka",
            "Datum",
            "Odlazak",
            "Odl-km",
            "Odl-gorivo",
            "Povratak",
            "#točenja",
            "Pov-km",
            "Pov-gorivo",
            "Potrošeno gor.",
            "Potrošnja l/100km",
            "Stopovi",
            "Vrijeme stajanja",
            "Vrijeme vožnje",
            "Vrijeme ukupno",
            "Pređeni put",
            "Komentar",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 38 },
          { column: 1, width: "8%" },
          { column: 2, width: "10%" },
          { column: 3, width: "10%" },
          { column: 4, width: 78 },
          { column: 5, width: 68 },
          { column: 6, width: 64 },
          { column: 7, width: 54 },
          { column: 8, width: 64 },
          { column: 9, width: 40 },
          { column: 10, width: 60 },
          { column: 11, width: 54 },
          { column: 12, width: 60 },
          { column: 13, width: 70 },
          { column: 14, width: 60 },
          { column: 15, width: 70 },
          { column: 16, width: 70 },
          { column: 17, width: 70 },
          { column: 18, width: 70 },
        ],
        edit: {
          column: [-1],
        },
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { row: [-1] },
        highlightedColor: colors[6],
        sumIncludeInSearch: true,
        sumSecretPhrase: "Σ",
        sumColumns: [
          { column: 0, type: "increment" },
          { column: 15, type: "time" },
          { column: 16, type: "time" },
          { column: 17, type: "time" },
          { column: 18, type: "decimal" },
        ],
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.tabClicked(1);
    // this.getDepartments();
  },
  methods: {
    tableCellClicked() {},

    cm(params, row, column) {
      console.log(params);
      console.log(row);
      console.log(column);
      console.log(this.params.data[row]);
      console.log(this.rawData[row - 1][14]);
      console.log(this.rawData[row - 1][15]);
      console.log(this.rawData[row - 1][16]);
      this.selectedVehicle = {
        vehicleId: this.rawData[row - 1][14],
        vehicleName: this.rawData[row - 1][15],
        licensePlate: this.rawData[row - 1][16],
      };
      if (column === 2) {
        this.openContextMenu(params);
      }
    },

    cmViewDetails() {
      console.log("selected vehicle");
      console.log(this.selectedVehicle);

      const theDate = new Date(
        this.firstDay.getTime() - this.firstDay.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.$router.push(
        "/user/VehicleDetails?date=" +
          theDate +
          "&vehicleId=" +
          this.selectedVehicle.vehicleId
      );
    },

    openContextMenu(e) {
      this.$refs.menu.open(e);
    },

    cmEditClicked() {
      this.$refs.menu.close();
    },

    resetUi() {
      this.params.data = [
        [
          "Ndx",
          "Vozač",
          "Vozilo",
          "Reg. oznaka",
          "Datum",
          "Odlazak",
          "Odl-km",
          "Odl-gorivo",
          "Povratak",
          "#točenja",
          "Pov-km",
          "Pov-gorivo",
          "Potrošeno gor.",
          "Potrošnja l/100km",
          "Stopovi",
          "Vrijeme stajanja",
          "Vrijeme vožnje",
          "Vrijeme ukupno",
          "Pređeni put",
          "Komentar",
        ],
      ];
      this.dailyLogs = [];
      this.rawData = [];
      this.employeeIdsBeenOnRoute = [];
    },

    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);

        // load data
        ReportService.GetRouteLogsForSimpleVehiclesV2ByStartDateAndEndDate(
          this.firstDay,
          this.lastDay
        ).then((response) => {
          console.log(response.data);
          this.pushData(response.data);
        });
      });
    },

    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },

    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },

    tabClicked(value) {
      this.tabSelector = value;
      if (value === 0) {
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        let today = new Date();
        yesterday.setHours(24, 0, 0, 0);
        today.setHours(24, 0, 0, 0);
        this.firstDay = yesterday;
        this.lastDay = today;
        this.resetUi();
        this.getDepartments();
      } else if (value === 1) {
        let dayBeforeYesterday = new Date(
          new Date().setDate(new Date().getDate() - 2)
        );
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        this.firstDay = dayBeforeYesterday;
        yesterday.setHours(24, 0, 0, 0);
        dayBeforeYesterday.setHours(24, 0, 0, 0);
        this.lastDay = yesterday;
        this.resetUi();
        this.getDepartments();
      } else if (value === 2) {
        this.firstDay = null;
        this.lastDay = null;
        this.resetUi();
      }
      this.resetUi();
      this.selectedEmployee = null;
    },

    timeSpanChosen(span) {
      if (span[0] == null || span[1] == null) {
        return;
      }
      this.firstDay = span[0];
      this.lastDay = span[1];
      this.resetUi();
      this.getDepartments();
    },

    onCellChange(rowIndex, columnIndex, data) {
      console.log("onCellChange: ", rowIndex, columnIndex, data);
      console.log("table data: ", this.$refs.table.getData());
    },

    pushData(data) {
      let ndx = 1;

      let totalValue = new Array(14).fill(0);

      data.forEach((oe) => {
        // console.log("mačak");
        // console.log(oe.fuelFills.length);
        // this.rawData.push(oe);

        console.log(oe);

        // Calculate vehicle stop length
        oe.totalStopTime = 0;
        oe.vehicleStops.forEach((vs) => {
          oe.totalStopTime += vs.durationTicks;
        });
        oe.totalDriveTime = oe.duration - oe.totalStopTime;
        console.log(oe.totalStopTime);

        totalValue[0] += oe.duration;
        totalValue[1] += oe.kilometerSpent;
        totalValue[2] += oe.totalStopTime;
        totalValue[3] += oe.totalDriveTime;

        // Override tour name with vehicle license plates
        oe.tourName = this.$store.state.general.vehicles.filter(
          (v) => v.vehicleId == oe.vehicleId
        )[0].licensePlate;

        this.rawData.push([
          ndx++,
          oe.driverName,
          oe.vehicleModel,
          oe.tourName,
          oe.startByGps.split("T")[0],
          oe.startByGps.split("T")[1],
          (oe.kilometerStart / 1000).toFixed(0),
          oe.fuelStartL === 0
            ? oe.fuelStart + "%"
            : (oe.fuelStartL / 10).toFixed(0) + " L",
          oe.endByGps.split("T")[1],
          oe.fuelFills.length > 0 ? oe.fuelFills.length : "-",
          (oe.kilometerStop / 1000).toFixed(0),
          oe.fuelStopL === 0
            ? oe.fuelStop + "%"
            : (oe.fuelStopL / 10).toFixed(0) + " L",
          oe.fuelStart - oe.fuelStop, // Potrošeno goriva
          "-",
          oe.vehicleStops.length > 0 ? oe.vehicleStops.length : "-",
          maskIfEquealsValue(getDateFromTicks(oe.totalStopTime), "00:00:00"),
          maskIfEquealsValue(getDateFromTicks(oe.totalDriveTime), "00:00:00"),
          maskIfEquealsValue(getDateFromTicks(oe.duration), "00:00:00"),
          maskIfEquealsValue((oe.kilometerSpent / 1000).toFixed(2), "0"),
          "",
          oe.vehicleId,
          oe.vehicleModel,
          oe.licensePlate,
        ]);
      });

      // data loaded, push
      this.rawData.forEach((element) => {
        this.params.data.push([
          element[0],
          element[1],
          element[2],
          maskIfEquealsValue(element[3], "0"),
          maskIfEquealsValue(element[4], "0.00"),
          maskIfEquealsValue(element[5], "0"),
          maskIfEquealsValue(element[6], "0"),
          maskIfEquealsValue(element[7], "0"),
          maskIfEquealsValue(element[8], "0"),
          maskIfEquealsValue(element[9], "0"),
          maskIfEquealsValue(element[10], "0"),
          maskIfEquealsValue(element[11], "0"),
          maskIfEquealsValue(element[12], "0"),
          maskIfEquealsValue(element[13], "0"),
          maskIfEquealsValue(element[14], "0"),
          maskIfEquealsValue(element[15], "0"),
          maskIfEquealsValue(element[16], "0"),
          maskIfEquealsValue(element[17], "0"),
          maskIfEquealsValue(element[18], "0"),
          element[19],
        ]);
      });

      // push last row
      this.params.data.push([
        "",
        "Σ (za vremenski raspon)",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        maskIfEquealsValue(getDateFromTicks(totalValue[2]), "00:00:00"),
        maskIfEquealsValue(getDateFromTicks(totalValue[3]), "00:00:00"),
        maskIfEquealsValue(getDateFromTicks(totalValue[0]), "00:00:00"),
        maskIfEquealsValue((totalValue[1] / 1000).toFixed(2), "0"),
        "",
      ]);
    },
  },
};
</script>

<style scoped>
.small {
  font-size: 11px !important;
}
</style>
